var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeraConfirm',{attrs:{"text":this.$t(
      '_web_error-unable-to-copy-link',
      "Can't copy link to clipboard, try do it by yourself"
    ),"cancel-button-text":false,"confirm-button-text":_vm.confirmBtnLabel || _vm.$t('_web_leave-confirm-ok', 'OK')},on:{"confirm":_vm.confirmLeave}},[_c('p',{staticClass:"text-center mt-4"},[_vm._v("\n    "+_vm._s(_vm.link)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }